import React from "react";
import { ReloadOutlined, SearchOutlined } from "@ant-design/icons";

// 搜索面板配置
export const searchPanelConfig = {
  title: "角色搜索",
  columns: 3,
  collapsible: false,
  defaultCollapsed: false,
  actions: {
    searchText: "搜索",
    resetText: "重置",
  },
};

// 在模块内保存一次性表单取值函数，供标题栏按钮回调使用
let getCurrentSearchValues: (() => any) | null = null;

/**
 * 角色搜索表单字段配置
 */
export const createSearchConfig = () => ({
  fields: [
    {
      name: "name",
      label: "角色名称",
      type: "input" as const,
      placeholder: "请输入角色名称",
    },
    {
      name: "code",
      label: "角色代码",
      type: "input" as const,
      placeholder: "请输入角色代码",
    },
    {
      name: "status",
      label: "状态",
      type: "select" as const,
      options: [
        { label: "全部", value: "" },
        { label: "启用", value: "active" },
        { label: "禁用", value: "inactive" },
      ],
    },
  ],
});

// 搜索面板按钮配置（用于 ContainerPanel.buttons）
export const getSearchPanelButtons = (
  handleReset: () => void,
  handleSearch: (values?: any) => void
) => [
    {
      key: "reset",
      text: searchPanelConfig.actions.resetText,
      type: "default" as const,
      icon: React.createElement(ReloadOutlined),
      onClick: handleReset,
    },
    {
      key: "search",
      text: searchPanelConfig.actions.searchText,
      type: "primary" as const,
      icon: React.createElement(SearchOutlined),
      onClick: () => {
        // 若已拿到内部表单实例，则携带表单值触发搜索；否则退化为不带参搜索
        if (getCurrentSearchValues) {
          const values = getCurrentSearchValues();
          handleSearch(values);
        } else {
          handleSearch();
        }
      },
    },
  ];

// CompsSearch 的 props 生成器
export const getSearchProps = (
  searchItems: any[],
  onSearch: (values?: any) => void,
  onReset: () => void,
  // 可选：向外暴露表单实例
  onFormRef?: (form: any) => void
) => {
  return {
    searchItems,
    columns: searchPanelConfig.columns,
    onSearch,
    onReset,
    collapsible: false,
    // 捕获表单实例用于标题栏按钮获取当前值
    formRef: (form: any) => {
      getCurrentSearchValues = () => form.getFieldsValue();
      if (onFormRef) onFormRef(form);
    },
  };
};


